import type { BusbarSelectionRunResponse } from "../services/busbarSelection";
import { BusbarSelectionResultPanel } from "./BusbarSelectionResultPanel";
import { BusbarSelectionResultSummary } from "./BusbarSelectionResultSummary";
import { BusbarSelectionTraceability } from "./BusbarSelectionTraceability";
import { BusbarSelectionWarningPanel } from "./BusbarSelectionWarningPanel";
import { SldLinkPanel } from "./SldLinkPanel";

type BusbarSelectionResultProps = {
  response: BusbarSelectionRunResponse;
  onExport?: () => void;
};

// The result of a busbar selection run in the order of Master Prompt v2.1 section 19: the
// summary, the run's link to the single-line diagram (nothing when the revision had no
// diagram), the warnings, the traceability (with the controlled data set the run was
// calculated with), then the detail. Display only: every status and value is the engine's.
export function BusbarSelectionResult({ response, onExport }: BusbarSelectionResultProps) {
  return (
    <>
      <BusbarSelectionResultSummary result={response.result} />
      <SldLinkPanel link={response.run.sld_link} />
      <BusbarSelectionWarningPanel result={response.result} />
      <BusbarSelectionTraceability
        run={response.run}
        dataSet={response.data_set}
        onExport={onExport}
      />
      <BusbarSelectionResultPanel result={response.result} />
    </>
  );
}

export default BusbarSelectionResult;
